"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._gui_test = void 0;
require("@progress/kendo-ui");
require("babel-polyfill");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
require("jquery-address");
const SynView_1 = require("../SynView");
require("./_gui_test.tmpl.less");
const $ = require("jquery");
class _gui_test extends SynView_1.SynView {
    //#region MEMBER VARIABLES
    //#endregion MEMBER VARIABLES
    //#region CONSTRUCTOR
    constructor() {
        super();
        this.m_hasMenu = false;
        this.m_hasContextMenu = false;
    }
    //#endregion CONSTRUCTOR
    //#region MEMBER METHODS
    //#region Inherited from SynView
    init(viewName, viewIndex, viewHtml) {
        super.init(viewName, viewIndex, viewHtml);
    }
    resizeControls() {
    }
    renderContents() {
        let tests = require.context("./tests", false, /_tests\.ts$/i);
        let testSelection = [""];
        tests.keys().forEach((fileName) => {
            testSelection.push(fileName);
        });
        $("#testSelectionPane").find("#testSelection").kendoComboBox({
            dataSource: testSelection,
            select: (e) => {
                $("#testContentPane").remove();
                $("#guiTests").append("<div id='testContentPane'></div>");
                if (e.dataItem !== "")
                    tests(e.dataItem).renderTest();
            }
        });
    }
    forceRefresh(modifications) { }
}
exports._gui_test = _gui_test;
